import { CartArrowDownIcon } from './CartArrowDownIcon';

/**
 * author: Simran
 * id 0DCB3032-271E-4522-ABEE-386F49E6B4ED
 * name cart-arrow-down
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cart-arrow-down.svg
 * tags
 * - Shopping 
 */
export const ShoppingCartArrowDownIcon = CartArrowDownIcon;
export default ShoppingCartArrowDownIcon